import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../utility";

const initialState = {
  data: null,
  pic: null,
  loading: null,
  loadingPic: null,
  error: null,
  msg: null,
};

const fetchInfoStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchInfoSuccess = (state, action) => {
  return updateObject(state, {
    data: action.data,
    error: null,
    loading: false,
  });
};

const fetchInfoFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const updateInfoStart = (state, action) => {
  return updateObject(state, { msg: null, error: null, loading: true });
};

const updateInfoSuccess = (state, action) => {
  return updateObject(state, {
    msg: action.msg,
    data: action.newInfo,
    error: null,
    loading: false,
  });
};

const updateInfoFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    msg: null,
  });
};

const updateClearSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    loadingPic: false,
    msg: null,
  });
};

const passwordUpdateStart = (state, action) => {
  return updateObject(state, { msg: null, error: null, loading: true });
};

const passwordUpdateSuccess = (state, action) => {
  return updateObject(state, {
    msg: action.msg,
    error: null,
    loading: false,
  });
};

const passwordUpdateFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    msg: null,
  });
};
const passwordUpdateClearError = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

// for picture
const fetchPicStart = (state, action) => {
  return updateObject(state, { error: null, loadingPic: true });
};

const fetchPicSuccess = (state, action) => {
  return updateObject(state, {
    pic: action.pic,
    error: null,
    loadingPic: false,
  });
};

const fetchPicFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loadingPic: false,
  });
};

const uploadPicStart = (state, action) => {
  return updateObject(state, { error: null, loadingPic: true });
};

const uploadPicSuccess = (state, action) => {
  return updateObject(state, {
    pic: action.newPic,
    msg: action.msg,
    error: null,
    loadingPic: false,
  });
};

const uploadPicFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loadingPic: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // for info
    case actionTypes.FETCH_INFO_START:
      return fetchInfoStart(state, action);
    case actionTypes.FETCH_INFO_SUCCESS:
      return fetchInfoSuccess(state, action);
    case actionTypes.FETCH_INFO_FAIL:
      return fetchInfoFail(state, action);

    case actionTypes.UPDATE_INFO_START:
      return updateInfoStart(state, action);
    case actionTypes.UPDATE_INFO_SUCCESS:
      return updateInfoSuccess(state, action);
    case actionTypes.UPDATE_INFO_FAIL:
      return updateInfoFail(state, action);

    // for password
    case actionTypes.UPDATE_PASSWORD_START:
      return passwordUpdateStart(state, action);
    case actionTypes.UPDATE_PASSWORD_SUCCESS:
      return passwordUpdateSuccess(state, action);
    case actionTypes.UPDATE_PASSWORD_FAIL:
      return passwordUpdateFail(state, action);

    // for Picture
    case actionTypes.FETCH_PIC_START:
      return fetchPicStart(state, action);
    case actionTypes.FETCH_PIC_SUCCESS:
      return fetchPicSuccess(state, action);
    case actionTypes.FETCH_PIC_FAIL:
      return fetchPicFail(state, action);

    case actionTypes.UPLOAD_PIC_START:
      return uploadPicStart(state, action);
    case actionTypes.UPLOAD_PIC_SUCCESS:
      return uploadPicSuccess(state, action);
    case actionTypes.UPLOAD_PIC_FAIL:
      return uploadPicFail(state, action);

    // for clear
    case actionTypes.UPDATE_CLEAR_SUCCESS_MSG:
      return updateClearSuccess(state, action);
    case actionTypes.CLEAR_ERROR:
      return passwordUpdateClearError(state, action);
    default:
      return state;
  }
};

export default reducer;
